import React from "react";
import { Helmet } from "react-helmet";
import cx from "classnames";
import styles from "./Page.module.scss";

export interface PageProps {
  className?: string;
  containerClassName?: string;
  bodyClassName?: string;
  center?: boolean;
  title?: string;
  header?: React.ReactNode;
  footer?: React.ReactNode;
}

const Page: React.FC<PageProps> = ({
  className,
  containerClassName,
  bodyClassName,
  children,
  center,
  title,
  header,
  footer,
}) => {
  return (
    <main className={cx(styles.page, className, { [styles.center]: center })}>
      {title && (
        <>
          <Helmet>
            <title>{title}</title>
          </Helmet>
        </>
      )}
      {header}
      <div className={cx(styles.container, containerClassName)}>
        <div className={cx(styles.body, bodyClassName)}>{children}</div>
      </div>
      {footer}
    </main>
  );
};

export default Page;
